import { FC, useEffect, useState } from 'react';
import { RecordValueWithSensograms } from '../../../services/cache/idb';
import { computeSignature } from '../../analysis/signature';
import { getSignatureFigure } from '../../analysis/figures';
import Plotly from 'plotly.js';
import Plot from 'react-plotly.js';
import { DEFAULT_PLOTLY_CONFIG, DEFAULT_PLOTLY_LAYOUT } from '../../../utils/constants/constants';

export const SingleSignatureFigure: FC<{
  record: RecordValueWithSensograms;
  shouldAggregate: boolean;
}> = ({ record, shouldAggregate }) => {
  const [plotlyData, setPlotlyData] = useState<Plotly.Data[]>([]);
  const [plotlyLayout, setPlotlyLayout] = useState<Partial<Plotly.Layout>>({});

  useEffect(() => {
    let [_signature, _spotsgrid1d] = computeSignature(record);
    let { data, layout } = getSignatureFigure(_spotsgrid1d, _signature);

    layout = {
      ...DEFAULT_PLOTLY_LAYOUT,
      ...layout,
    };

    setPlotlyData(data);
    setPlotlyLayout(layout);
  }, [record.baselineStart, record.baselineEnd, record.analyteStart, record.analyteEnd, shouldAggregate]);

  return (
    <Plot
      data={plotlyData}
      layout={plotlyLayout}
      config={DEFAULT_PLOTLY_CONFIG}
      style={{
        width: '100%',
        height: '100%',
        margin: 'auto',
      }}
      useResizeHandler
    />
  );
};
